import Link from 'next/link';
import styles from './sponsor.module.css';
import { UserProfileUser } from '../../src/models/socket/profile';
import UserProfileComponent from '../../components/user/userprofilecomponent';
import Title from '../../components/global/title';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { GetServerSideProps } from 'next';

type Props = {
    sponsorshipText: string;
};

export const getServerSideProps = (async () => {
    const fs = await import('node:fs/promises');
    let sponsorshipText = "*SPQR* is a passion project. Please don't feel compelled to sponsor *SPQR*, it will continue to be around. But it does cost about $50/month to continue to run the site. If you'd like to help you can use [PayPal](https://www.paypal.com/pool/9gGHRxPYNd?sr=wccr), [VenMo](https://venmo.com/u/chad3814)(last four digits is 4155), [CashApp](https://cash.app/$chad3814w) or join the [Patreon](https://patreon.com/SPQR_Game).";

    try {
        sponsorshipText = await fs.readFile('/app/storage/sponsorship.md', 'utf-8');
    } catch (err) {
        // ignore
    }

    return {
        props: {
            sponsorshipText,
        }
    };
}) satisfies GetServerSideProps<{
    sponsorshipText: string;
}>

export default function SponsorPage({ sponsorshipText }: Props) {
    const porty: UserProfileUser = {
        id: 4,
        name: 'porty',
        avatar: '110_HeadFront.png',
        created: new Date(),
    };

    const chad: UserProfileUser = {
        id: 1,
        name: 'chad',
        avatar: '512655d4aaa5cd7abe349579_HeadFront.png',
        created: new Date(),
    };

    const zandy: UserProfileUser = {
        id: 2,
        name: 'Zandy',
        avatar: '254_HeadFront.png',
        created: new Date(),
    };

    return <div id="content" className={styles.container}>
        <Title subtitle="Sponsor" />
        <h1>Sponsorship</h1>
        <Markdown remarkPlugins={[remarkGfm]}>{sponsorshipText}</Markdown>
        <h2>About</h2>
        <div><em>SPQR</em> started through a frustration the <Link href="http://warfish.net" target="_blank">Warfish</Link> constantly down and out-of-date. A group of friends on a <Link href="https://join.slack.com/t/spqr-app/shared_invite/zt-2jr4vnyr8-_QBoEvx3Em2A8Sy88CHd2w" target="_blank">slack</Link> (mostly software developers) dreamed of taking over or re-writing it.</div>
        <div>During the Christmas break in 2022, <UserProfileComponent className={styles.profile} user={porty} /> got the ball rolling and created the base of what we know as <em>SPQR</em> today. <UserProfileComponent className={styles.profile} user={chad} /> already had the domain name (thinking it would spur him to action) and hosted of sites, and <UserProfileComponent className={styles.profile} user={zandy} /> contributed code, reviews and motivation to continue. In January 2023 it was up and the group of friends played their first games on the new site.</div>
        <div>Over the last 18 months there have been hundreds of commits (click the six numbers and letters below for a log), and vast improvements. The group of friends expanded a bit, <UserProfileComponent className={styles.profile} user={chad} /> reached out to random people on the internet that used to play on Warfish, and now there are more than 100 accounts and 30-40 daily active users. <em>SPQR</em> has exceeded my (chad) expectations, and I&apos;m proud of how far it has come.</div>
        <div className={styles.signature}><em>-<UserProfileComponent className={styles.profile} user={chad} /></em></div>
    </div>
}
